function devtricker_dom_comment_setLikeIconStyle(commentId, style) {

    const iconElement = document.querySelector(`#li-comment-${commentId} .up-vote-button .icon`);
    if (!iconElement) return;

    iconElement.classList.remove('icon-heart', 'icon-heart-fill');

    const newClass = style === 'fill' ? 'icon-heart-fill' : 'icon-heart';
    iconElement.classList.add(newClass);
}

function devtricker_dom_comment_setChevronIconStyle(commentId, style) {

    const iconElement = document.querySelector(`#li-comment-${commentId} .reply-counter .icon`);
    if (!iconElement) return;

    iconElement.classList.remove('icon-chevron-down', 'icon-chevron-up');

    const newClass = style === 'down' ? 'icon-chevron-down' : 'icon-chevron-up';
    iconElement.classList.add(newClass);
}

function devtricker_dom_comment_updateLikeCounter(commentId, value = 1) {
    let commentSelector = `#li-comment-${commentId}`;
    let likeCounterElement = document.querySelector(`${commentSelector} .up-vote-counter`);

    if (!/[a-zA-Z]/.test(likeCounterElement.textContent)) {
        let likeCount = parseInt(likeCounterElement.textContent.trim()) || 0;

        if (likeCount < 999) {
            let finalCount = likeCount + value; 

            if(finalCount <= 0){
                likeCounterElement.textContent = '';
            }else{
                likeCounterElement.textContent = finalCount;
            }
        } else if (likeCount === 999) {
            likeCounterElement.textContent = ' 1k ';
        }
    }
}